import Button from 'carbon-react/lib/components/button';
import Form from 'carbon-react/lib/components/form';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  children: ReactNode;
  footerContent?: ReactNode;
  onClose?: () => void;
  saveDisabled: boolean;
  isEditing: boolean;
  onDelete?: () => void;
  onSave?: () => void;
  onSaveAndNew?: () => void;
}
export const PredictionFormContainer = ({
  children,
  footerContent,
  onClose,
  saveDisabled,
  isEditing,
  onDelete,
  onSave,
  onSaveAndNew
}: Props) => (
  <Form
    stickyFooter
    leftSideButtons={footerContent}
    rightSideButtons={
      <>
        <Button onClick={onClose}>
          <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
        </Button>
        {isEditing && (
          <Button destructive onClick={onDelete}>
            <FormattedMessage id="common.delete" defaultMessage="Delete" />
          </Button>
        )}
        <Button buttonType="primary" onClick={onSave} disabled={saveDisabled}>
          <FormattedMessage id="predict.save_prediction" defaultMessage="Save prediction" />
        </Button>
        <Button buttonType="primary" onClick={onSaveAndNew} disabled={saveDisabled}>
          <FormattedMessage id="predict.save_and_new" defaultMessage="Save and new" />
        </Button>
      </>
    }
    onSubmit={e => e.preventDefault()}
  >
    <div>{children}</div>
  </Form>
);
